<template>
    <b-card>
        <b-row>
            <b-col md="5">
                <b-card-img rounded center fluid :src="infoData.imagen"></b-card-img>
            </b-col>
            <b-col md="7">
                <b-row>
                    <p class="mb-0" style="font-size: 21px">{{infoData.nombre}}</p>
                </b-row>
                <b-row class="color-personalized">
                    <b-col md="6">
                        <b-row no-gutters class="row-background-personalized">
                            <b-col cols="6" class="text-left">
                                Referencia:
                            </b-col>
                            <b-col cols="6" class="text-right">
                                {{infoData.codigo}}
                            </b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col cols="6" class="text-left">
                                Existencia: 
                            </b-col>
                            <b-col cols="6" class="text-right">
                                {{numberFormat(infoData.existencia)}}
                            </b-col>
                        </b-row>
                        <b-row no-gutters class="row-background-personalized">
                            <b-col cols="6" class="text-left">
                                Código de Barras: 
                            </b-col>
                            <b-col cols="6" class="text-right">
                                {{infoData.codigo_barras}}
                            </b-col>
                        </b-row>
                        <b-row no-gutters v-for="(item, index) of itemAttributes" :key="index">
                            <b-col cols="6" class="text-left">
                                {{item.atributo.nombre}}: 
                            </b-col>
                            <b-col cols="6" class="text-right">
                                {{item.valor}}
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row no-gutters>
                            <b-col cols="6" class="text-left">
                                Precio: 
                            </b-col>
                            <b-col cols="6" class="text-right">
                                $ {{numberFormat(infoData.precio)}} COP
                            </b-col>
                        </b-row>
                        <b-row no-gutters class="pb-2">
                            <b-col class="text-right">
                                <p v-if="infoData.porcentaje_impuesto !== 0">
                                    Iva incluido
                                </p>
                                <p v-else>
                                    No Incluye Iva
                                </p>
                            </b-col>
                        </b-row>
                        <b-row no-gutters class="pb-2">
                            <b-col cols="6">
                                <b-form-input
                                    v-model="cantidad"
                                    type="number"
                                    required
                                    placeholder="Cantidad"
                                    ></b-form-input>
                            </b-col>
                            <b-col cols="6" class="text-right">
                                <b-button type="submit" variant="success" 
                                @click.prevent="addItemToCart(cantidad, infoData.codigo)">
                                    Agregar
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-card no-body class="card-personalized">
                    <b-tabs card>
                    <b-tab title="Descripción" active>
                        <b-card-text v-if="infoData.descripcion" v-html="infoData.descripcion">
                            {{infoData.descripcion}}
                        </b-card-text>
                        <b-card-text v-else>
                            No se ha ingresado una descripción para el producto
                        </b-card-text>
                    </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
    data(){
        return{
            infoData: {},
            cantidad: 1,
            response: '',
            itemAttributes: {},
            variant: ''
        }
    },
    created(){
        this.getItemDetail();
    },
    methods: {
        ...mapMutations(['setLoading']),
        ...mapActions('configuration', {
          _getCartCount: 'getCartItemsCountByUser',
        }),
        async getItemDetail(){
            this.setLoading(true)
            await this.$conectar.post('/articulos/get-item-empresa-detail', {codigo: this.$route.params.codigo})
            .then(response => {
                this.infoData = response.data.itemDetail;
                this.itemAttributes = response.data.itemAttributesValues;
            })
            .catch(response => {
                console.log(response);
            })
            this.setLoading(false)
        },
        async addItemToCart(data, codigo){
            this.setLoading(true)
            await this.$conectar.post('/articulos/add-item-empresa-to-cart', { cantidad: data, codigo: codigo})
            .then(response =>{
                 if (response.data.error == false) { 
                    this._getCartCount();
                    this.$root.$bvToast.toast(response.data.mensaje, {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                }else{
                    this.$root.$bvToast.toast(response.data.mensaje, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(error => {
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                console.log(error);
                
            })
            this.setLoading(false)
            this.cantidad = 1;
        }
    }
}
</script>
<style scoped>
.card-img { 
    max-width: 100%; 
    max-height: 400px;
    object-fit: scale-down;
}
.color-personalized {
    background: #dcdde1 !important;
    }

.singleLine {
  white-space: nowrap !important;
  overflow: hidden !important;
}

.card-personalized {
  min-height: 200px;
}
.row-background-personalized{
    background: white!important;
}
</style>